import React, {Fragment, PureComponent} from "react";
import {
  Row,
  Card,
  CardBody,
  CardTitle,
} from 'reactstrap';
import ReactTable from 'react-table';
import {withTranslation} from 'react-i18next';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import {reactTableText} from "../../../../constants/configs";
import Api from "../../../../services/Api";
import {upperCase} from "lodash";
import Switch from "react-switch";
import Breadcrumb from "../../../../containers/navs/Breadcrumb";

class List extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      event: [],
      announcement: [],
      declaration: [],
      loading: {
        announcement: true,
        declaration: true,
        event: true,
      },
    };
    this.renderSwitchCell = this.renderSwitchCell.bind(this);
  }

  fetchSettings = async type => {
    try {
      const {data} = await Api.invoke('GET', `/v2/admin-ui/notifications/${upperCase(type)}/channels`);
      this.setState(state => ({
        ...state,
        [type]: [{type, ...data}],
      }));
    } catch (e) {
      console.log("error: ", e);
    } finally {
      this.setState(state => ({
        ...state,
        loading: {
          ...state.loading,
          [type]: false,
        },
      }));
    }
  };

  updateSettings = async (type, name, values) => {
    try {
      await Api.invoke('PATCH', `/v2/admin-ui/notifications/${upperCase(type)}/channels/${name}`, values);
      await this.fetchSettings(type);
    } catch (e) {
      console.log("error: ", e);
    }
  };

  renderSwitchCell = props => {
    const {enabled} = props.value;
    return (
      <Switch
        className="mt-2 ltr"
        onChange={async enabled => {
          await this.updateSettings(props.original.type, props.column.id, {enabled});
        }}
        checked={!!enabled}
        height={24}
        width={45}
      />
    );
  };

  getColumns = () => {
    const {t} = this.props;
    return [
      {
        Header: t('SMS Channel'),
        accessor: 'SMS',
        Cell: this.renderSwitchCell,
      },
      {
        Header: t('EMAIL Channel'),
        accessor: 'EMAIL',
        Cell: this.renderSwitchCell,
      },
      {
        Header: t('PUSH Channel'),
        accessor: 'FIRE_BASE',
        Cell: this.renderSwitchCell,
      },
      // {
      //   Header: t('TELEGRAM Channel'),
      //   accessor: 'TELEGRAM',
      //   Cell: this.renderSwitchCell,
      // },
    ];
  };

  render() {
    const {t, match} = this.props;
    const {loading, event, announcement, declaration} = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary">
                  {t('Announcements')}
                </CardTitle>
                <ReactTable
                  manual
                  className="-highlight"
                  pageSize={1}
                  data={announcement}
                  sortable={false}
                  resizable={true}
                  showPagination={false}
                  columns={this.getColumns()}
                  loading={loading.announcement}
                  style={{width: '100%', marginBottom: 50}}
                  onFetchData={async () => {await this.fetchSettings('announcement');}}
                  {...reactTableText}
                />
                <CardTitle className="text-large text-primary">
                  {t('Declarations')}
                </CardTitle>
                <ReactTable
                  manual
                  className="-highlight"
                  pageSize={1}
                  data={declaration}
                  sortable={false}
                  resizable={true}
                  showPagination={false}
                  columns={this.getColumns()}
                  loading={loading.declaration}
                  style={{width: '100%', marginBottom: 50}}
                  onFetchData={async () => {await this.fetchSettings('declaration');}}
                  {...reactTableText}
                />
                <CardTitle className="text-large text-primary">
                  {t('Events')}
                </CardTitle>
                <ReactTable
                  manual
                  className="-highlight"
                  pageSize={1}
                  data={event}
                  sortable={false}
                  resizable={true}
                  showPagination={false}
                  loading={loading.event}
                  columns={this.getColumns()}
                  style={{width: '100%', marginBottom: 50}}
                  onFetchData={async () => {await this.fetchSettings('event');}}
                  {...reactTableText}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
